<button mat-icon-button [matMenuTriggerFor]="actionsMenu" class="menu-button">
    <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #actionsMenu="matMenu">
    <ng-container>
        @if(!enabled && enableAction)
        {
            <button mat-menu-item (click)="enableAction()">
                <mat-icon>visibility_on</mat-icon>
                Enable
            </button>
        }
        @if(enabled && disableAction)
        {
            <button mat-menu-item (click)="disableAction()">
                <mat-icon>visibility_off</mat-icon>
                Disable
            </button>
        }
        @if (translateAction) {
            <button mat-menu-item (click)="translateAction()" class="translate-button">
                <mat-icon>translate</mat-icon>
                Labels
            </button>
        }
        @if (editAction) {
            <button mat-menu-item (click)="editAction()" class="edit-button">
                <mat-icon>edit</mat-icon>
                Edit
            </button>
        }
        @if (deleteAction) {
            <button mat-menu-item (click)="deleteAction()" class="delete-button">
                <mat-icon color="warn">delete</mat-icon>
                Delete
            </button>
        }
    </ng-container>
</mat-menu>

